/* ============= ↓ STAFF CARD/MODAL LINKS ↓ ============= */
// [[src/assets/js/components/_staff-card.js]]
// [[src/assets/js/components/_staff-modal.js]]
// [[src/assets/js/pages/staff-page.js]]
/* ============= ↑ STAFF CARD/MODAL LINKS ↑ ============= */
import { html } from "../base/_utils.js";

export const staff = [
    /* Markup #480 - Jill La Point removed */
    // Jennifer Cunningham
    {
        id: "jenniferCunningham",
        image: "assets/media/pages/staff/headshots/jennifer-cunningham.webp",
        name: "Jennifer Cunningham",
        title: "Senior Associate AD/SA Dev. & Internal Ops./SAAC Advisor",
        email: "jennifer.cunningham@providence.edu",
        phone: "401.865.1880",
        bio: html`
            <p>
                Cunningham has worked at Providence College since July of 2007. She began her career at PC in the External Relations/Fundraising office and transitioned to student-athlete development
                in 2021. She most recently served as the Associate Athletic Director for Student-Athlete Development & Internal Operations. Cunningham oversees the Friar Edge Student-Athlete
                Development program and serves as the co-advisor for SAAC (Student-Athlete Advisory Council). Cunningham also serves as the sport administrator for the Softball program and secondary
                sport administrator to the Field Hockey and Women's' Basketball programs.. She is an active member of the National Association of Academic & Student-Athlete Development Professionals
                (N4A) and Women Leaders in Sports. Cunningham is a graduate of the 2020 NCAA Leadership Academy Workshop, 2015 Women Leaders Institute for Advancement, 2022 Women Leaders LEI
                (Leadership Enhancement Institute) and also served on the Education and Professional Development Committee for Women Leaders in Sports in 2023-2024.
            </p>
        `,
    },
    // Laura Pellecchia
    {
        id: "lauraPellecchia",
        image: "assets/media/pages/staff/headshots/laura-pellecchia.webp",
        name: "Laura Pellecchia",
        title: "Sr. Associate Director of Experiential Learning & Funded Programs",
        bio: html` <p>Bio coming soon.</p> `,
    },
    // Mariana Perez
    {
        id: "marianaPerez",
        image: "assets/media/pages/staff/headshots/mariana-perez.webp",
        name: "Mariana Perez",
        title: "Assistant Athletic Director of Compliance & NIL Coordination",
        bio: html`
            <p>
                Mariana is beginning her first year with Providence College as an Assistant Director of Compliance and NIL Coordinator. She has received a Bachelor of Arts in Communication Studies and
                Criminology/Law Studies at Marquette University and a Juris Doctorate from California Western School of Law. Prior to joining Providence College, she has worked in the athletics
                marketing department for Marquette University, has served as a Compliance officer at California State University at San Marcos, and as an Assistant Director of Compliance at San Diego
                State University. She loves working with student-athletes and is passionate about helping them cultivate their success inside and outside of athletics.
            </p>
        `,
    },
    // MarkUp #1 — Harold Starks removed
    // Lynne Hebert
    // MarkUp #493
    {
        id: "lynneHebert",
        image: "assets/media/pages/staff/headshots/lynee-hebert.webp",
        name: "Lynne Hebert, RD",
        title: "Assistant Athletic Director for Nutrition Performance",
        bio: html`
            <p>
                As a registered dietitian with a focus in performance nutrition, Lynne strives to bring every student-athlete to an optimum baseline of health for training, recovery, and performance.
                She holds a bachelor's degree in health science nutrition from Keene State College where she was an athlete in track & field. She completed her post-graduate dietetic internship in
                sustainable food systems and dietetic systems leadership at Montana State University. Before her time at Providence College, Lynne was a dietitian in sports nutrition at Stanford
                University.
            </p>
        `,
    },
    // Fr. Dominic Verner
    // MarkUp #494
    {
        id: "dominicVerner",
        image: "assets/media/pages/staff/headshots/dominic-verner.webp",
        name: "Fr. Dominic Verner, O.P.",
        title: "Athletics Chaplain",
        bio: html`
            <p>
                After earning a B.S. in electrical engineering from Purdue University and an M.A. in philosophical studies from Mount St. Mary's University, Fr. Dominic Verner, O.P. entered the Order
                of Preachers and was ordained to the priesthood in 2016. He earned an S.T.L. from the Pontifical Faculty of the Immaculate Conception and a Ph.D. in moral theology/Christian ethics
                from the University of Notre Dame, where he wrote his dissertation "Saving Honor: A Thomistic Ethics of Honor." He joined the Theology Faculty at Providence College as an Assistant
                Professor in the Fall of 2022. His research and teaching interests especially concern the motivational role that honor, reputation, and social recognition play in practical reason and
                how the doctrine and example of Christ norm the pursuit of these goods. Fr. Dominic favors an interdisciplinary approach to these and related questions concerning honorable human
                agency, seeking to engage Thomistic anthropology and action theory with contemporary social theory, psychology, and neuroscience.
            </p>
        `,
    },
    // Jeimmy Alonzo
    // MarkUp #495
    {
        id: "jeimmyAlonzo",
        image: "assets/media/pages/staff/headshots/jeimmy-alonzo.webp",
        name: "Jeimmy Alonzo",
        title: "Academic Coordinator for Student-Athletes",
        bio: html`
            <p>
                Jeimmy Alonzo is the Academic Coordinator for Student-Athletes at Providence College, supporting the mission of Friar Athletics. She works directly with student-athletes, coaches, and
                campus partners to help Friars excel both in competition and in the classroom.
            </p>
            <p>
                Alonzo earned her Master of Education degree from Providence College in December 2025 and joined the Student-Athlete Academic Services team in January 2026. Her work focuses on
                fostering academic achievement, personal development, and timely progress toward graduation while helping student athletes successfully navigate the unique demands of collegiate
                athletics.
            </p>
        `,
    },
    // Dr. Christopher Bilder
    {
        id: "christopherBilder",
        image: "assets/media/pages/staff/headshots/christopher-bilder.webp",
        name: "Dr. Christopher Bilder",
        title: "Staff Psychologist/Associate Director of Clinical Sport Psychology Services",
        email: "cbilder@providence.edu",
        bio: html`
            <p>
                Dr. Chris Bilder, a licensed clinical sport psychologist, is the Associate Director of Clinical Sport Psychology Services. Dr. Bilder was most recently a Sport Psychologist for
                Northwestern University in Evanston, IL where he worked with coaches, teams, and individual student-athletes across every team at the University. Dr. Bilder also served as the liaison
                for PURPLE (Peers Urging Responsible Practice through Leadership and Education) student-athlete leadership group, and he was a founding member of the Northwestern Athletics Sports
                Medicine DEI group.
            </p>
            <p>
                Dr. Bilder completed his doctoral internship and postdoctoral residency at Lehigh University, where he worked with men's and women's swimming and diving, women's field hockey, and
                men's and women's rowing. He received his Doctorate in Clinical Psychology from James Madison University and his Masters of Sport & Performance Psychology from the University of
                Denver. He practices using an integrative model, utilizing cognitive behavioral, mindfulness-acceptance-commitment, emotion focused, psychodynamic, humanistic, and systems approaches.
                Outside of work he enjoys spending time with his family, going to the beach, watching sports, playing adult league hockey, golfing, and pottery.
            </p>
        `,
    },
    // Shaun Crank
    {
        id: "shaunCrank",
        image: "assets/media/pages/staff/headshots/shaun-crank.webp",
        name: "Shaun Crank",
        title: "Assistant Director/Career Coach",
        email: "scrank@providence.edu",
        phone: "401.865.1746",
        bio: html`
            <p>
                Shaun has built his career around working with students and young adults. He has 13+ years of career services experience through working in higher Education as well as the non-profit
                sector. Shaun holds a Bachelor of Science Degree in Marketing. He will be working with students in their pursuit toward building the necessary professional skills and tool skits to
                achieve post-graduation success. Shaun is passionate about diversity, inclusion, and is looking forward to building collaborative relationships with faculty and staff to best support
                the Providence College student body with their career readiness.
            </p>
        `,
    },
];
